import { Component, OnInit } from '@angular/core';
import { MatDialog, MatDialogConfig } from '@angular/material/dialog';
import { DocDialogComponent } from './doc-dialog/doc-dialog.component';
import { DocumentEnum } from '../../../services/documentsOperation/DocumentEnum';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { DocumentsService } from 'src/app/services/documentsOperation/documents-service.service';
import { UserDetailsService } from 'src/app/services/user-details.service';
import { ToastrService } from 'ngx-toastr';
import { ActivatedRoute } from '@angular/router';
import { Subscription } from 'rxjs';
import { trigger, transition, style, animate } from '@angular/animations';

@Component({
  selector: 'app-doc-center',
  templateUrl: './doc-center.component.html',
  styleUrls: ['./doc-center.component.scss'],
  animations: [
    trigger('slideUp', [
      transition(':enter', [
        style({ transform: 'translateY(100%)', opacity: 0 }),
        animate('600ms ease-out', style({ transform: 'translateY(0)', opacity: 1 }))
      ]),
    ])
  ]
})
export class DocCenterComponent implements OnInit {
  DocumentEnum = DocumentEnum;
  private refreshSub: Subscription;

  document_list: any = [];
  toggleAddDoc: boolean = true;
  firstTimeLoad: boolean;

  constructor(
    private dialog: MatDialog,
    private modalService: NgbModal,
    private documentService: DocumentsService,
    private userDetailService: UserDetailsService,
    private route: ActivatedRoute,
    public toastr: ToastrService
  ) { }

  ngOnInit(): void {
    this.getUserDocuments();
    this.refreshSub = this.documentService.documentRefreshed$.subscribe(() => {
      this.getUserDocuments();
    });
    this.firstTimeLoad = true;
  }

  ngOnDestroy() {
    if (this.refreshSub) {
      this.refreshSub.unsubscribe();
    }
  }

  getUserDocuments() {
    let user_id = this.route.parent?.snapshot.paramMap.get('id');
    if (!user_id) {
      user_id = this.userDetailService.getUserDetails()?.id;
    }
    this.documentService.getUserDocuments(user_id).subscribe({
      next: (data) => {
        const allowedTypes = [
          DocumentEnum.AADHAAR,
          DocumentEnum.PAN,
          DocumentEnum.VOTER_ID,
          DocumentEnum.ADDRESS_PROOF,
        ];
        const previousCount = this.document_list?.length || 0;
        this.document_list = (data?.body || []).filter((doc) =>
          allowedTypes.includes(doc.documentType)
        );

        const currentCount = this.document_list.length;
        const allUploaded = currentCount === allowedTypes.length;

        if (allUploaded) {
          if (!this.firstTimeLoad && previousCount !== currentCount) {
            this.toastr.success(
              'All documents have been successfully uploaded.',
              'Success'
            );
          }
          this.toggleAddDoc = false;
        } else {
          if (!this.firstTimeLoad && previousCount < currentCount) {
            this.toastr.success('Document has been successfully uploaded.', 'Success');
          }
          this.toggleAddDoc = true;
        }

        this.firstTimeLoad = false;
      },
      error: () => { },
    });
  }


  openAddDocumentModel() {
    const uploadedTypes = this.document_list.map((doc) => doc.documentType);
    // let aadharNo;
    // let aadharName;

    // for(let i in this.document_list){
    //   if(this.document_list[i].documentType==DocumentEnum.AADHAAR)
    //   {
    //     aadharNo=this.document_list[i].document_number;
    //     aadharName=this.document_list[i].name_on_document;
    //     break;
    //   }
    // }
    const dialogConfig = new MatDialogConfig();
    dialogConfig.disableClose = true;
    dialogConfig.autoFocus = true;
    dialogConfig.width = '75vw';
    dialogConfig.height = '50vh';
    dialogConfig.data = {
      type: 'ADD',
      doc: null,
      uploadedTypes: uploadedTypes,
      // aadharNo: aadharNo,
      // aadharName:aadharName
    };
    dialogConfig.panelClass = 'activate-employee';

    const dialogRef = this.dialog.open(DocDialogComponent, dialogConfig);
    dialogRef.afterClosed().subscribe((data) => {
      if (data?.isUploaded) {
        this.getUserDocuments();
      }
    });
  }


  refetchDocuments(event) {
    this.getUserDocuments();
  }
}
